import vue from 'vue'
import {apolloClient} from '@/graphql/apolloWrapper'
import {GET_CHANNELS_LIST} from "../../graphql/queries/channels/list";
import {GET_CHANNEL_DUPLICATES_ACTIVE_LIST} from "../../graphql/queries/channels/activeDuplicates";
import {CHANNELS_UPDATE} from "../../graphql/mutations/channels/update";

const state = {
  channels: [],
  groups: [],
  duplicates: []
};

const getters = {
  isGroupLoaded: (state) => (group) => state.groups.includes(group),
  getChannelsBySiteini: (state) => (siteini) => state.channels.filter(channel => {
    return (!channel.license || !channel.license.id) && (channel.siteini.site === siteini);
  }),
  getChannelsByLicense: (state) => (licenseId) => state.channels.filter(channel => {
    return channel.license && channel.license.id === licenseId
  }),
  isChannelActiveDuplicate: (state) => (identifier) => state.duplicates.includes(identifier),
};

const mutations = {
  UPDATE_CHANNEL_LIST (state, channels) {
    channels.forEach(channel => {
      state.channels.upsert({id: channel.id}, channel)
    })
    // state.channels = channels.concat(state.channels);
  },
  APPEND_LOADED_GROUP (state, group) {
    state.groups.push(group)
  },
  UPDATE_CHANNEL_LICENSE (state, {licenseId, channelIds}) {
    state.channels.forEach((channel, index) => {
      if (channelIds.includes(channel.id)) {
        channel.license = {id: licenseId};
        vue.set(state.channels, index, channel)
        this.commit('INCREMENT_SITEINI_USED_COUNT', {siteini: channel.siteini.site, count: licenseId ? 1 : -1})
        // state.channels[index].license = {id: licenseId};
      }
    })
  },
  UPDATE_CHANNEL_DUPLICATES_LIST (state, duplicateIdentifiers) {
    state.duplicates = duplicateIdentifiers;
  },

};

const actions = {
  async channelsFetchDuplicatesActive ({commit}) {
    const {data} = await apolloClient.query({query: GET_CHANNEL_DUPLICATES_ACTIVE_LIST});
    if (data && data.channelActiveDuplicates) {
      commit('UPDATE_CHANNEL_DUPLICATES_LIST', data.channelActiveDuplicates);
      return true;
    }
    return false;
  },
  async channelsFetchList ({commit, state, getters}, filters) {
    const {data} = await apolloClient.query({query: GET_CHANNELS_LIST, variables: filters});
    if (data && data.channelList) {
      commit('UPDATE_CHANNEL_LIST', data.channelList);
      return true;
    }
    return false;
  },
  async channelsByLicenseId ({commit, dispatch, getters}, licenseId) {
    if (!getters.isGroupLoaded(licenseId)) {
      const filters = {'licenseId': licenseId};
      const success = dispatch('channelsFetchList', filters);
      if (success) {
        commit('APPEND_LOADED_GROUP', licenseId);
      }
    }
  },
  async channelsBySiteini ({commit, dispatch, getters}, siteini) {
    if (!getters.isGroupLoaded(siteini)) {
      const filters = {'siteini': siteini, 'licenseId': null};
      const success = dispatch('channelsFetchList', filters);
      if (success) {
        commit('APPEND_LOADED_GROUP', siteini);
      }
    }
  },
  async assignLicenseToChannels ({commit}, input) {
    const {data} = await apolloClient.mutate({
      mutation: CHANNELS_UPDATE,
      variables: {channels: input.channels, input: {license_id: input.licenseId}}
    });
    if (data && data.channelsUpdate) {
      commit('UPDATE_CHANNEL_LICENSE', {
        licenseId: input.licenseId,
        channelIds: input.channels
      });
      // dispatch('channelsByLicenseId', input.licenseId)
    }
  }
};

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/channels.js